import { store, storeFuns } from "sw-hic";

storeFuns.init({
  state: {
    enum: {
      HospitalizationState: ["已登记", "已入住", "已撤销", "已离院", "已结算"], 
      DepositType: ["收费", "退费"],
      DepositOccasion: ["入院缴费", "在院补缴", "离院补缴", "离院退费"],
      SettlementStatus: ["未结算", "已结算"],
      IousAuditState: ["审批中", "通过", "驳回"],
      CriticalLevel: ["濒危", "危重", "急症", "非急症"],
      IpType: ["自费", "医保", "医保工伤"],
      BillType: ["出院单据号", "住院号"],
      DiagnosisType: ["西医", "中医"],
      NursingItemType:['专项护理', '分级护理'],
      PatientGroup: ["留置看护", "武警看护"],
    },
  },
});
export default store